import React, { useEffect, useId, useRef, useState } from 'react';

export default function CharacterDraftMenu({ children, modalOpen = false, saveButton, autosave, onToggleAutosave }) {
    const [open, setOpen] = useState(false);
    const container = useRef(null);
    const trigger = useRef(null);
    const panel = useRef(null);
    const id = useId();

    useEffect(() => {
        if (!open || modalOpen) return;
        panel.current?.querySelector('button:not(:disabled)')?.focus();
        const dismiss = event => {
            if (!container.current?.contains(event.target)) setOpen(false);
        };
        document.addEventListener('pointerdown', dismiss);
        return () => document.removeEventListener('pointerdown', dismiss);
    }, [open, modalOpen]);

    return <div className="character-draft-menu" ref={container}
        onBlur={event => {
            if (!modalOpen && event.relatedTarget && !event.currentTarget.contains(event.relatedTarget)) setOpen(false);
        }}
        onKeyDown={event => {
            if (event.key === 'Escape' && !event.defaultPrevented) {
                event.preventDefault(); setOpen(false); trigger.current?.focus();
            }
        }}>
        {saveButton}
        <button type="button" className="character-drafts-trigger" ref={trigger} aria-label="Save options" title="Save options"
            aria-expanded={open} aria-controls={id}
            onClick={() => setOpen(value => !value)}>
            <svg aria-hidden="true" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="m6 9 6 6 6-6" />
            </svg>
        </button>
        <div ref={panel} id={id} className="character-drafts-panel" hidden={!open}>
            {children}
            <button type="button" className="character-autosave" role="switch" aria-checked={!!autosave}
                aria-label="Autosave" onClick={onToggleAutosave}>
                Autosave
                <span className="character-autosave-track" aria-hidden="true"><span /></span>
            </button>
        </div>
    </div>;
}
